import React, { useEffect, useRef } from "react";
// import { gsap } from "gsap";
import { Container, Col, Row } from "react-bootstrap";
import "./AboutWelcome.css";
import aboutWelcome from "../../../Images/aboutWelcome.png";
function AboutWelcome() {
  return (
    <>
      <section className="about-welcome">
        <Container>
          {/* <Row>
            <Col md={12}> 
              <div className="">
                <h1>Lorem ipsum dolor sit amet, conse ctetur adipiscing</h1>
              </div>
            </Col>
          </Row> */}
          <Row>
            <Col md={7}>
              <div className="aboutwelcome_herotext">
              <h1>About Us</h1>
              <p>
              "Moneysukh" is a well-known and experienced brokerage firm with its corporate office in New Delhi.  We have a large network of branches and Authorized Persons in over 300 locations across India with regional offices situated at Mumbai, Chandigarh, and Kolkatta.  We are Member of NSE, BSE, NCDEX, MCX, and DP with NSDL and CDSL. We provide a diverse range of Trading and Investment Solutions to all types of investors and traders. Promoted and led by a team of professionals with over 30 years of experience in the securities markets, we
               have an advanced in-house R&D wing with some of the best people, processes, and technology resources to provide complete research solutions on equity, commodities, IPOs, and mutual funds. We have a team of more than 1000 dedicated and highly motivated employees with diverse academic backgrounds such as CA, Engineers, Data Scientist, CS, M.B.A, and other varied fields.
              </p>
              </div>
            </Col>
            <Col md={5}>
              <img
                className="img-fluid"
                src={aboutWelcome}
                alt={aboutWelcome}
              />
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
}
export default AboutWelcome;
